import { useCallback, useEffect, useState } from 'react'

export const useLayoutHeight = () => {
  const [statusBannerEl, setStatusBannerEl] = useState<HTMLDivElement | null>(null)
  const [systemNotificationsEl, setSystemNotificationsEl] = useState<HTMLDivElement | null>(null)
  const [topBarEl, setTopBarEl] = useState<HTMLDivElement | null>(null)

  const statusBannerRef = useCallback((node: HTMLDivElement | null) => setStatusBannerEl(node), [])
  const systemNotificationsRef = useCallback(
    (node: HTMLDivElement | null) => setSystemNotificationsEl(node),
    []
  )
  const topBarRef = useCallback((node: HTMLDivElement | null) => setTopBarEl(node), [])

  const updateLayoutHeight = useCallback(() => {
    document.documentElement.style.setProperty(
      '--status-banner-height',
      `${statusBannerEl?.clientHeight || 0}px`
    )
    document.documentElement.style.setProperty(
      '--system-notifications-height',
      `${systemNotificationsEl?.clientHeight || 0}px`
    )
    document.documentElement.style.setProperty(
      '--topbar-height',
      `${topBarEl?.clientHeight || 0}px`
    )
  }, [statusBannerEl, systemNotificationsEl, topBarEl])

  useEffect(() => {
    const resizeObserver = new ResizeObserver(() => updateLayoutHeight())
    ;[statusBannerEl, systemNotificationsEl, topBarEl].forEach(
      (el) => el && resizeObserver.observe(el)
    )
    updateLayoutHeight()

    return () => {
      resizeObserver.disconnect()
    }
  }, [statusBannerEl, systemNotificationsEl, topBarEl, updateLayoutHeight])

  return { statusBannerRef, systemNotificationsRef, topBarRef }
}
